<template>
  <b-card class="!border-[1px] !border-[#E2E2E2] !border-solid !shadow-none">
    <div class="flex items-start justify-between flex-wrap gap-[12px] mb-[4px]">
      <div>
        <h3 class="font-semibold text-[#333333] text-[20px] mb-[6px]">
          Kelola Kategori
        </h3>
        <p class="text-[14px] text-[#626262] mb-0">
          Atur dan kelola kategori campaign untuk platform.
        </p>
      </div>
      <b-button
        variant="primary"
        class="!flex items-center justify-center gap-[8px] !rounded-[8px]"
        @click="showModalTambah = true"
      >
        <span class="k-add text-[18px]" />
        Tambah Kategori
      </b-button>
    </div>

    <kategori-table
      :items="items"
      :loading="loading"
      @toggle-status="onToggleStatus"
      @edit="onEditCategory"
    />
    <modal-tambah-kategori
      v-model="showModalTambah"
      :existing-names="existingNames"
      @success="fetchCategories"
    />
    <modal-edit-kategori
      v-model="showModalEdit"
      :category-data="selectedCategory"
      :existing-names="existingNames"
      @success="fetchCategories"
    />
    <modal-konfirmasi-nonaktifkan
      v-model="showModalKonfirmasi"
      :category-name="pendingToggle.categoryName"
      :campaign-count="pendingToggle.campaignCount"
      :creator-count="pendingToggle.creatorCount"
      @confirm="confirmToggleStatus"
      @cancel="cancelToggleStatus"
    />
  </b-card>
</template>

<script>
import KategoriTable from './components/KategoriTable.vue'
import ModalTambahKategori from './components/ModalTambahKategori.vue'
import ModalEditKategori from './components/ModalEditKategori.vue'
import ModalKonfirmasiNonaktifkan from './components/ModalKonfirmasiNonaktifkan.vue'

export default {
  name: 'KategoriPage',
  components: {
    KategoriTable,
    ModalTambahKategori,
    ModalEditKategori,
    ModalKonfirmasiNonaktifkan,
  },
  data() {
    return {
      loading: false,
      showModalTambah: false,
      showModalEdit: false,
      showModalKonfirmasi: false,
      selectedCategory: null,
      items: [],
      pendingToggle: {
        item: null,
        isActive: null,
        categoryName: '',
        campaignCount: 0,
        creatorCount: 0,
      },
    }
  },
  computed: {
    existingNames() {
      return this.items.map(i => i.name)
    },
  },
  mounted() {
    this.fetchCategories()
  },
  methods: {
    onEditCategory(item) {
      this.selectedCategory = item
      this.showModalEdit = true
    },
    async fetchCategories() {
      this.loading = true
      try {
        const response = await this.$http_new.get('/komclass/api/v1/komlabs/campaigns/options/product-category')
        const list = response?.data?.data || response?.data || []
        this.items = list.map(item => {
          const isActive = item.is_active === 1 || item.is_active === true
          const categoryName = item.option_label || item.name || item.option_name || item.label || ''
          let status
          if (categoryName.toLowerCase() === 'lain-lain') {
            status = 'default'
          } else {
            status = isActive ? 'active' : 'inactive'
          }
          return {
            id: item.id,
            name: categoryName,
            status,
            total_campaign: item.total_campaigns || item.total_campaign || 0,
            total_creator: item.total_creators || item.total_creator || 0,
            is_active: isActive,
            is_updating: false,
          }
        })
      } catch (error) {
        if (this.$toast_error) {
          this.$toast_error({ message: 'Gagal memuat data kategori.' })
        }
      } finally {
        this.loading = false
      }
    },

    /**
     * Ubah status aktif kategori
     * PATCH /komclass/api/v1/komlabs/campaigns/options/{id}/update
     */
    async onToggleStatus({ item, isActive }) {
      // Jika mengubah menjadi inactive (nonaktifkan)
      if (!isActive) {
        const campaignCount = item.total_campaign || 0
        const creatorCount = item.total_creator || 0

        // Jika kategori tidak digunakan oleh campaign dan kreator, langsung proses tanpa modal
        if (campaignCount === 0 && creatorCount === 0) {
          await this.processToggleStatus(item, isActive)
          return
        }

        // Jika kategori masih digunakan, tampilkan modal konfirmasi
        this.pendingToggle = {
          item,
          isActive,
          categoryName: item.name,
          campaignCount,
          creatorCount,
        }
        this.showModalKonfirmasi = true
        return
      }

      // Jika mengaktifkan (dari inactive ke active), langsung proses tanpa konfirmasi
      await this.processToggleStatus(item, isActive)
    },

    /**
     * User membatalkan konfirmasi nonaktifkan
     */
    cancelToggleStatus() {
      // Force re-render item untuk mengembalikan toggle ke posisi semula
      if (this.pendingToggle.item) {
        const targetItem = this.items.find(i => i.id === this.pendingToggle.item.id)
        if (targetItem) {
          // Trigger reactivity dengan mengubah nilai sementara
          targetItem.is_updating = true
          this.$nextTick(() => {
            targetItem.is_updating = false
          })
        }
      }

      // Reset pendingToggle
      this.pendingToggle = {
        item: null,
        isActive: null,
        categoryName: '',
        campaignCount: 0,
        creatorCount: 0,
      }
    },

    /**
     * User mengkonfirmasi nonaktifkan
     */
    async confirmToggleStatus() {
      const { item, isActive } = this.pendingToggle
      if (item) {
        await this.processToggleStatus(item, isActive)
      }
      // Reset pendingToggle
      this.pendingToggle = {
        item: null,
        isActive: null,
        categoryName: '',
        campaignCount: 0,
        creatorCount: 0,
      }
    },

    /**
     * Proses toggle status ke API
     */
    async processToggleStatus(item, isActive) {
      const targetItem = this.items.find(i => i.id === item.id)
      if (!targetItem) return

      const prevActive = targetItem.is_active
      const prevStatus = targetItem.status

      // Optimistic UI update
      targetItem.is_active = isActive
      if (targetItem.status !== 'default') {
        targetItem.status = isActive ? 'active' : 'inactive'
      }
      targetItem.is_updating = true

      try {
        await this.$http_new.patch(`/komclass/api/v1/komlabs/campaigns/options/${targetItem.id}/update`, {
          is_active: isActive ? 1 : 0,
        })
        if (this.$toast_success) {
          this.$toast_success({ message: `Status kategori ${targetItem.name} berhasil diperbarui.` })
        }
      } catch (error) {
        // Rollback jika API gagal
        targetItem.is_active = prevActive
        targetItem.status = prevStatus
        if (this.$toast_error) {
          this.$toast_error({ message: `Gagal memperbarui status kategori ${targetItem.name}.` })
        }
      } finally {
        targetItem.is_updating = false
      }
    },
  },
}
</script>
